import { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { enablePush, pushSupported } from '../lib/push';
import { useI18n } from '../lib/i18n';

/**
 * Botón "activar notificaciones" en el topbar. Solo aparece si el navegador soporta
 * push y el permiso AÚN no fue concedido (granted → ya llega push, no molestamos;
 * denied → el navegador no deja re-pedir desde aquí). Se auto-oculta al activarse.
 */
export function EnablePushButton() {
  const { t } = useI18n();
  const [state, setState] = useState<'idle' | 'busy' | 'hidden'>('idle');

  useEffect(() => {
    if (!pushSupported() || Notification.permission !== 'default') setState('hidden');
  }, []);

  if (state === 'hidden') return null;

  async function turnOn() {
    setState('busy');
    try { await enablePush(); setState('hidden'); }
    catch { setState('idle'); }
  }

  return (
    <button
      onClick={turnOn}
      disabled={state === 'busy'}
      className="btn ghost sm"
      title={t('notif.pushHelp')}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 9px' }}
    >
      <Bell size={15} strokeWidth={2} />
      {t('notif.enablePush')}
    </button>
  );
}
